import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VesTransactionsService } from '../../../services/ves-transactions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reject-referencia-modal',
  templateUrl: './reject-referencia-modal.component.html',
})
export class RejectReferenciaModalComponent {
  referencia: any;
  reasonForm: FormGroup;
  loading = false;

  constructor(
    private vesTransactionsService: VesTransactionsService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RejectReferenciaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.referencia = data;
    this.reasonForm = this.fb.group({
      reason: new FormControl('', [Validators.required, Validators.minLength(3)]),
    });
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  reject(): void {
    if (this.reasonForm.invalid || this.loading) return;
    this.loading = true;

    const reason = this.reasonForm.get('reason')?.value;

    this.vesTransactionsService.rejectReferenciaVes(this.referencia.id, reason).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Referencia rechazada',
          text: 'La referencia ha sido rechazada.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'Error al rechazar la referencia',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
